module.exports = __webpack_public_path__ + "assets/img/year-content-bg.cc8efd7f.png";